<div class="page-container">
    <!-- Header -->
    <app-header title="{{ 'offer-letter.people' | translate }}" [menuService]="employeeModuleMenuService">
        <div class="buttons">
            <ui-button type="primary" url="../new" [queryParams]="queryParams">{{
                'offer-letter.sendOfferLetter' | translate
            }}</ui-button>
        </div>
    </app-header>

    <!-- Table -->
    <div *ngIf="table">
        <app-table [table]="table">
            <app-empty-state
                label="{{ 'offer-letter.currentlyNoOffers' | translate }}"
                src="/assets/illustrations/sofa.png"
            ></app-empty-state>
        </app-table>
    </div>
</div>
